import type { SocialProfile } from '@/components/composite/Caption/types';

import { DefaultAvatar as Avatar } from '@/components/base/Avatar';

interface CaptionAvatarProps {
    profile: SocialProfile | null;
    className?: string;
}

export const CaptionAvatar = ({ profile, className = 'mr-5' }: CaptionAvatarProps) => {
    if (!profile) {
        return null;
    }

    return (
        <Avatar
            url={profile.external_api_data?.avatar ?? null}
            fallback={profile.slug?.charAt(0) ?? 'U'}
            profileType={profile.social_network_type}
            className={className}
        />
    );
};
